/// What a finished `run_capability` read hands the browser: `{ ok: true, text }`. The first line
/// of `text` is the /v1 response's `data` as JSON, with nulls and empty nested arrays stripped by
/// the server; later lines are follow-up hints meant for the model. Anything else (a refusal, the
/// bare "ok" a body-less response produces, text that is not JSON) is not drawable.
export interface CopilotReadPayload {
  capability: string;
  data: unknown;
  /** The arguments the read ran with, e.g. whose reports were listed. */
  input: unknown;
}

function fieldOf(value: unknown, key: string): unknown {
  return typeof value === "object" && value !== null ? Reflect.get(value, key) : undefined;
}

function stringField(value: unknown, key: string): string | null {
  const field = fieldOf(value, key);
  return typeof field === "string" ? field : null;
}

export function readCopilotPayload(args: unknown, result: unknown): CopilotReadPayload | null {
  const capability = stringField(args, "name");
  if (!capability) return null;
  if (typeof result !== "object" || result === null) return null;
  if (Reflect.get(result, "ok") !== true) return null;
  const text = stringField(result, "text");
  if (text === null) return null;
  const firstLine = text.split("\n", 1)[0] ?? "";
  try {
    const data: unknown = JSON.parse(firstLine);
    return { capability, data, input: fieldOf(args, "args") };
  } catch {
    return null;
  }
}
